import React from 'react'

import { useSelector, useDispatch } from 'customizer/hooks'
import { setMobileDescription } from 'customizer/questionPanel/actions'
import { mobileDescriptionSelector } from 'customizer/questionPanel/selectors'
import SanitizedHtml from 'themes/common/components/SanitizedHtml'
import type { DescriptionStyle } from 'themes/common/types/style'

import MobileDescriptionHeader from './MobileDescriptionHeader'

interface MobileDescriptionPopupProps {
  className?: string
  descriptionStyle: DescriptionStyle
}

const MobileDescriptionPopup = ({ className, descriptionStyle, ...props }: MobileDescriptionPopupProps) => {
  const dispatch = useDispatch()

  const mobileDescription = useSelector(mobileDescriptionSelector)

  const handleClosePopup = () => dispatch(setMobileDescription(null))

  if (!mobileDescription?.showDescription) return null

  return (
    <div className={className} style={descriptionStyle} {...props} data-testid="popup-container">
      <MobileDescriptionHeader title={mobileDescription.name} closePopup={handleClosePopup} />
      <div className="description__content">
        <SanitizedHtml
          dirtyHtml={mobileDescription.description}
          tagsStyle={{ a: `color: ${descriptionStyle.linkColor};` }}
        />
      </div>
    </div>
  )
}

export default MobileDescriptionPopup
